import { EmptyState } from "./EmptyState";
import { SubscriptionGrid } from "./SubscriptionGrid";
import { type ViewingPeriod } from "@/lib/periodStorageUtils";
import { type Subscription } from "@/types/subscription";

interface SubscriptionListContentProps {
  filteredSubscriptions: Subscription[];
  totalSubscriptions: number;
  subscriptionsInPeriod: number;
  currentPeriod: ViewingPeriod;
  periodDisplay: string;
  onEdit: (subscriptionId: string) => void;
}

export const SubscriptionListContent = ({
  filteredSubscriptions,
  totalSubscriptions,
  subscriptionsInPeriod,
  currentPeriod,
  periodDisplay,
  onEdit,
}: SubscriptionListContentProps) => {
  return (
    <div className="space-y-4">
      {filteredSubscriptions.length === 0 ? (
        <EmptyState
          totalSubscriptions={totalSubscriptions}
          subscriptionsInPeriod={subscriptionsInPeriod}
          periodDisplay={periodDisplay}
        />
      ) : (
        <SubscriptionGrid
          subscriptions={filteredSubscriptions}
          currentPeriod={currentPeriod}
          onEdit={onEdit}
        />
      )}
    </div>
  );
};

SubscriptionListContent.displayName = "SubscriptionListContent";
